type Props = {
  onClick?: (e?: any) => void;
};

const BackArrowButton = ({ onClick }: Props) => (
  <div onClick={onClick} data-testid="back-arrow-click-area">
    <svg width="40px" height="40px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <title>9F724B1D-09FC-4AAD-8262-1FF77ECFB56C</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        strokeDasharray="0,0"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g
          id="Icons/Interface/Arrows-and-Chevrons-/-ic-chevron-simple-left-stroked"
          fillRule="nonzero"
          stroke="#000000"
          strokeWidth="2"
        >
          <g
            id="Icons-/-Arrows-and-Chevrons-/-ic-chevron-simple-left-stroked"
            transform="translate(14.000000, 11.000000)"
          >
            <path d="M5,10 L0,5 L5,0" id="Vector"></path>
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default BackArrowButton;
